export class ListTableContextFilesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "files",
            "baseName": "files",
            "type": "Array<TableContextFile>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListTableContextFilesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
